import axios from "axios";
import {
  IContactInfoRequest,
  IContactInfoResponse,
  IEmployeeProfilePhotoRequest,
  IEmployeeProfilePhotoResponse,
  IEmployeeProfileRequest,
  IEmployeeProfileResponse,
  IFaqDetailsRequest,
  IFaqDetailsResponse,
  IFaqListRequest,
  IFaqListResponse,
  IWorkingConditionsRequest,
  IWorkingConditionsResponse,
} from "models/Employee/employeeProfile.model";
import { ITokenModel } from "models/Login/token.model";
import { store } from "redux/store";

export const EmployeeProfileInfo = async (
  empParams: ITokenModel
): Promise<IEmployeeProfileResponse> => {
  const reqData = serviceEmpModelCreator(empParams);
  try {
    const { data } = await axios.post<IEmployeeProfileResponse>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${empParams.access_token}`,
        },
      }
    );
    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;

    return data;
  } catch (error: any) {
    console.log(`EMPLOYEEPROFILE_SERVICE_ERROR => `, error);
    throw error;
  }
};

const serviceEmpModelCreator = (
  empParams: ITokenModel
): IEmployeeProfileRequest => {
  let req = {
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: empParams.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "MPSProfile/ProfileDetail",
  };

  return req;
};

export const EmployeeProfilePhoto = async (
  empParams: ITokenModel
): Promise<IEmployeeProfilePhotoResponse> => {
  const reduxStore = store.getState();
  const usrLvl = reduxStore.otp.userOtp?.UserLevel!;
  const reqData = serviceEmpProfilePhotoModelCreator(empParams, usrLvl);
  try {
    const { data } = await axios.post<IEmployeeProfilePhotoResponse>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${empParams.access_token}`,
        },
      }
    );

    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;
    return data;
  } catch (error: any) {
    console.log(`EMPLOYEEPROFILE_PHOTO_SERVICE_ERROR => `, error);
    throw error;
  }
};

const serviceEmpProfilePhotoModelCreator = (
  empParams: ITokenModel,
  usrLevel: string
): IEmployeeProfilePhotoRequest => {
  let req = {
    UserLevel: usrLevel,
    TokenSessionId: empParams.TokenSessionId,
    DeviceClientID:
      "D4EA46ECD43B2FBE655542AAE937425E113174F1AB197F8B115490B0528B0DB5D26F20FF01FFEFCF0545E82E64CF9832061016BAC9F9BFCAB4AD931282E8A692",
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    igsEnc: null,
    isScreenMirroring: false,
    NextTransactionUrl: "MPSProfileImage/ProfileImageGet",
  };

  return req;
};

export const ContactInfoAsync = async (
  contactParams: ITokenModel
): Promise<IContactInfoResponse> => {
  const reqData = serviceCantactInfoCreator(contactParams);
  try {
    const { data } = await axios.post<IContactInfoResponse>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${contactParams.access_token}`,
        },
      }
    );

    if (
      data.DialogBoxes.length > 0 ||
      (data.ReturnCode !== null && data.ReturnCode != 0)
    ) {
      let mssgg =
        data.DialogBoxes.length > 0
          ? data.DialogBoxes[0].Message
          : "Şu anda size hizmet veremiyoruz. Lütfen daha sonra tekrar deneyiniz.";
      return mssgg;
    }

    return data;
  } catch (error: any) {
    console.log(`CONTACTINFO_SERVICE_ERROR => `, error);
    return error;
  }
};

const serviceCantactInfoCreator = (
  contactParams: ITokenModel
): IContactInfoRequest => {
  let req = {
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: contactParams.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "MPSContactInfo/ContactInfo",
  };

  return req;
};

export const WorkingConditionsAsync = async (
  contactParams: ITokenModel
): Promise<IWorkingConditionsResponse> => {
  const reqData = serviceWorkingConditionsCreator(contactParams);
  try {
    const { data } = await axios.post<IWorkingConditionsResponse>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${contactParams.access_token}`,
        },
      }
    );
    if (data.DialogBoxes.length > 0) return data.DialogBoxes[0].Message;

    return data;
  } catch (error: any) {
    console.log(`WORKINGCONDITIONS_SERVICE_ERROR => `, error);
    return error;
  }
};

const serviceWorkingConditionsCreator = (
  contactParams: ITokenModel
): IWorkingConditionsRequest => {
  let req = {
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: contactParams.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "MPSProfile/ProfileTermsAndConditions",
  };

  return req;
};

export const DownloadPDF = async (
  url: string,
  pdfData: string
): Promise<Blob> => {
  try {
    const { data } = await axios.post<Blob>(url, pdfData, {
      responseType: "blob",
    });

    return data;
  } catch (error: any) {
    console.log(`PDFDOWNLOADER_SERVICE_ERROR => `, error);
    return error;
  }
};

export const FaqListAsync = async (
  faqParams: ITokenModel
): Promise<IFaqListResponse> => {
  const reqData = serviceFaqListCreator(faqParams);
  try {
    const { data } = await axios.post<IFaqListResponse>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${faqParams.access_token}`,
        },
      }
    );
    if (data.DialogBoxes.length > 0) return data.DialogBoxes[0].Message;

    return data;
  } catch (error: any) {
    console.log(`FAQLIST_SERVICE_ERROR => `, error);
    return error;
  }
};

const serviceFaqListCreator = (faqParams: ITokenModel): IFaqListRequest => {
  let req = {
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: faqParams.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "MPSFindFAQ/QuickActionAndFAQList",
  };

  return req;
};

export const FaqDetailsAsync = async (
  faqDetailParams: ITokenModel,
  faqId: string
): Promise<IFaqDetailsResponse> => {
  const reqData = serviceFaqDetailsCreator(faqDetailParams, faqId);
  try {
    const { data } = await axios.post<IFaqDetailsResponse>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${faqDetailParams.access_token}`,
        },
      }
    );
    if (data.DialogBoxes.length > 0) return data.DialogBoxes[0].Message;

    return data;
  } catch (error: any) {
    console.log(`FAQDETAILS_SERVICE_ERROR => `, error);
    return error;
  }
};

const serviceFaqDetailsCreator = (
  faqDetailParams: ITokenModel,
  faqId: string
): IFaqDetailsRequest => {
  let req: IFaqDetailsRequest = {
    FAQKey: faqId,
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: faqDetailParams.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "MPSFindFAQ/FAQDetails",
  };

  return req;
};
